import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["handle", "item", "position"]

  handleTargetConnected(handle) {
    handle.draggable = true
  }

  dragStart(event) {
    event.stopPropagation()

    this.draggedItem = event.target.closest('[data-sortable-list-target~="item"]')
    if (!this.directItems.includes(this.draggedItem)) return

    this.draggedItem.classList.add("opacity-50")
    event.dataTransfer.effectAllowed = "move"
  }

  dragOver(event) {
    event.stopPropagation()
    event.preventDefault()

    const overItem = event.currentTarget
    if (!this.draggedItem || overItem === this.draggedItem || !this.directItems.includes(overItem)) return

    const rect = overItem.getBoundingClientRect()
    const insertAfter = event.clientY > rect.top + (rect.height / 2)

    if (insertAfter) {
      overItem.after(this.draggedItem)
    } else {
      overItem.before(this.draggedItem)
    }

    this.updatePositions()
  }

  drop(event) {
    event.stopPropagation()
    event.preventDefault()
    this.updatePositions()
  }

  dragEnd(event) {
    event.stopPropagation()

    this.draggedItem?.classList.remove("opacity-50")
    this.draggedItem = null
    this.updatePositions()
  }

  updatePositions() {
    this.directItems.forEach((item, position) => {
      const positionField = this.directPositions.find((field) => field.closest('[data-sortable-list-target~="item"]') === item)
      if (positionField) positionField.value = position
    })
  }

  get directItems() {
    return this.itemTargets.filter((item) => item.closest('[data-controller~="sortable-list"]') === this.element)
  }

  get directPositions() {
    return this.positionTargets.filter((position) => position.closest('[data-controller~="sortable-list"]') === this.element)
  }
}
